import { useEffect } from 'react'
import { bootstrapTenant } from '@/lib/tenant-bootstrap'

/**
 * Kicks off the tenant bootstrap fetch exactly once at app mount. Errors are
 * logged but not thrown — downstream views handle missing tenant state through
 * their own guards and the bootstrap retry path.
 */
export function useTenantBootstrap(): void {
  useEffect(() => {
    bootstrapTenant().catch((error) => {
      console.error('Failed to bootstrap tenant:', error)
    })
  }, [])
}
